export default __webpack_public_path__ + "static/laser_engraving-9e97fe3c8e672c5089649766655c55f5.jpg";